import './index.css';

import { ConvexAuthProvider } from '@convex-dev/auth/react';
import { ConvexReactClient } from 'convex/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'next-themes';

import App from './App.tsx';
import { initSentry } from './lib/sentry';
import { TooltipProvider } from './components/ui/tooltip';

// Initialize Sentry before anything else
initSentry();

// Validate environment variables
const convexUrl = import.meta.env.VITE_CONVEX_URL as string;

if (!convexUrl) {
  const errorElement = document.createElement('div');
  errorElement.className = 'flex items-center justify-center min-h-screen p-4';
  errorElement.innerHTML = `
    <div class="text-center max-w-md mx-auto">
      <h1 class="text-2xl font-bold text-red-600 mb-4">Configuration Error</h1>
      <p class="text-gray-700 mb-4">
        Missing VITE_CONVEX_URL environment variable. Please create a .env file
        with your Convex URL.
      </p>
      <div class="bg-gray-100 p-3 rounded text-left text-sm font-mono">
        VITE_CONVEX_URL=https://your-convex-url.convex.cloud
      </div>
    </div>
  `;
  document.getElementById('root')!.appendChild(errorElement);
  throw new Error('VITE_CONVEX_URL environment variable is required');
}

const convex = new ConvexReactClient(convexUrl);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </ThemeProvider>
    </ConvexAuthProvider>
  </StrictMode>
);
